angular.module('olivioConfiguratorApp')
  .config(['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('de', TRANSLATIONS.de);
    $translateProvider.translations('en', TRANSLATIONS.en);
    $translateProvider.translations('fr', TRANSLATIONS.fr);

    // TODO: soll deutsche Sprache verwendet werden?
    // TODO GET-Parameter auswerten?
    // TODO kann $location.search().lang schon hier ausgewertet werden?
    $translateProvider.preferredLanguage('en');
    $translateProvider.fallbackLanguage('en');

  }]);


angular.module('olivioConfiguratorApp')
  .controller(
  'LanguageCtrl', ['$scope', '$location', '$translate', '$locale', 'Model', 'Data', function ($scope, $location, $translate, $locale, Model, Data) {
    //console.log('\n\n---------------\ninit LanguageCtrl');

    // data taken from angular-i18n. but there it is stored in a unusalbe way that inhibits dynamic nls changes and preloaded nls data
    // some of that data should depend of the region of the site visited (ie. currency. but this isn't used by now)
    var localeData = {
      'de': {
        "NUMBER_FORMATS": {
          "CURRENCY_SYM": "\u20ac",
          "DECIMAL_SEP": ",",
          "GROUP_SEP": ".",
          "PATTERNS": [
            {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 3,
              "minFrac": 0,
              "minInt": 1,
              "negPre": "-",
              "negSuf": "",
              "posPre": "",
              "posSuf": ""
            },
            {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 2,
              "minFrac": 2,
              "minInt": 1,
              "negPre": "-",
              "negSuf": "\u00a0\u00a4",
              "posPre": "",
              "posSuf": "\u00a0\u00a4"
            }
          ]
        },
        "id": "de-de",
        "localeID": "de_DE",
      },
      'en': {
        "NUMBER_FORMATS": {
          "CURRENCY_SYM": "\u20ac", //\u00a3",
          "DECIMAL_SEP": ".",
          "GROUP_SEP": ",",
          "PATTERNS": [
            {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 3,
              "minFrac": 0,
              "minInt": 1,
              "negPre": "-",
              "negSuf": "",
              "posPre": "",
              "posSuf": ""
            },
            {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 2,
              "minFrac": 2,
              "minInt": 1,
              "negPre": "-\u00a4",
              "negSuf": "",
              "posPre": "\u00a4",
              "posSuf": ""
            }
          ]
        },
        "id": "en-gb",
        "localeID": "en_GB"
      },
      'fr': {
        "NUMBER_FORMATS": {
          "CURRENCY_SYM": "\u20ac",
          "DECIMAL_SEP": ",",
          "GROUP_SEP": "\u00a0",
          "PATTERNS": [
            {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 3,
              "minFrac": 0,
              "minInt": 1,
              "negPre": "-",
              "negSuf": "",
              "posPre": "",
              "posSuf": ""
            },
            {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 2,
              "minFrac": 2,
              "minInt": 1,
              "negPre": "-",
              "negSuf": "\u00a0\u00a4",
              "posPre": "",
              "posSuf": "\u00a0\u00a4"
            }
          ]
        },
        "id": "fr-fr",
        "localeID": "fr_FR"
      }
      //,
      //'it': {
      //  "NUMBER_FORMATS": {
      //    "CURRENCY_SYM": "\u20ac",
      //    "DECIMAL_SEP": ",",
      //    "GROUP_SEP": ".",
      //    "PATTERNS": [
      //      {
      //        "gSize": 3,
      //        "lgSize": 3,
      //        "maxFrac": 3,
      //        "minFrac": 0,
      //        "minInt": 1,
      //        "negPre": "-",
      //        "negSuf": "",
      //        "posPre": "",
      //        "posSuf": ""
      //      },
      //      {
      //        "gSize": 3,
      //        "lgSize": 3,
      //        "maxFrac": 2,
      //        "minFrac": 2,
      //        "minInt": 1,
      //        "negPre": "-",
      //        "negSuf": "\u00a0\u00a4",
      //        "posPre": "",
      //        "posSuf": "\u00a0\u00a4"
      //      }
      //    ]
      //  },
      //  "id": "it-it",
      //  "localeID": "it_IT"
      //},
      //'tr': {
      //  "NUMBER_FORMATS": {
      //    "CURRENCY_SYM": "\u20ac", // "TL",
      //    "DECIMAL_SEP": ",",
      //    "GROUP_SEP": ".",
      //    "PATTERNS": [
      //      {
      //        "gSize": 3,
      //        "lgSize": 3,
      //        "maxFrac": 3,
      //        "minFrac": 0,
      //        "minInt": 1,
      //        "negPre": "-",
      //        "negSuf": "",
      //        "posPre": "",
      //        "posSuf": ""
      //      },
      //      {
      //        "gSize": 3,
      //        "lgSize": 3,
      //        "maxFrac": 2,
      //        "minFrac": 2,
      //        "minInt": 1,
      //        "negPre": "-\u00a4",
      //        "negSuf": "",
      //        "posPre": "\u00a4",
      //        "posSuf": ""
      //      }
      //    ]
      //  },
      //  "id": "tr-tr",
      //  "localeID": "tr_TR",
      //},
      //'es': {
      //  "NUMBER_FORMATS": {
      //    "CURRENCY_SYM": "\u20ac",
      //    "DECIMAL_SEP": ",",
      //    "GROUP_SEP": ".",
      //    "PATTERNS": [
      //      {
      //        "gSize": 3,
      //        "lgSize": 3,
      //        "maxFrac": 3,
      //        "minFrac": 0,
      //        "minInt": 1,
      //        "negPre": "-",
      //        "negSuf": "",
      //        "posPre": "",
      //        "posSuf": ""
      //      },
      //      {
      //        "gSize": 3,
      //        "lgSize": 3,
      //        "maxFrac": 2,
      //        "minFrac": 2,
      //        "minInt": 1,
      //        "negPre": "-",
      //        "negSuf": "\u00a0\u00a4",
      //        "posPre": "",
      //        "posSuf": "\u00a0\u00a4"
      //      }
      //    ]
      //  },
      //  "id": "es-es",
      //  "localeID": "es_ES"
      //}
    };


    $scope.$location = $location;
    $scope.model = Model.model;
    $scope.data = Data;
    $scope.lang = $translate.uses();

    var changeLanguage = function (lang) {
      $translate.preferredLanguage(lang);
      $translate.uses(lang);
      $scope.lang = $translate.uses();
      $locale.id = localeData[lang].id;
      $locale.NUMBER_FORMATS = localeData[lang].NUMBER_FORMATS;
    };

    var setLocale = function () {
      var locale = $location.search().lang;
      if(!locale) {
        console.log('locale not found, using default!');
      }
      locale = (locale === 'de' || locale === 'fr' ? locale : 'en');
      $scope.model.locale = locale;
      var language = $scope.data.locales[locale].language;
      if (language) {
        changeLanguage(language);
      } else {
        //console.log('language not found!');
      }
    };

    setLocale();
    $scope.$watch('$routeUpdate', setLocale, true);
  }]);


